/* @flow */

import type { JSON } from 'common/types';

export function retrieve(identifier: string): JSON {
  const value = base()[identifier];

  if (typeof value === 'undefined') {
    return null;
  }
  return value;
}

function base() {
  return (window && window.Putki) || {};
}
